import { render, staticRenderFns } from "./Asset-Overview-Schema.vue?vue&type=template&id=2d9ad6a8&scoped=true&lang=pug"
import script from "./Asset-Overview-Schema.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asset-Overview-Schema.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Asset-Overview-Schema.vue?vue&type=style&index=0&id=2d9ad6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ad6a8",
  null
  
)

export default component.exports